import React from 'react';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { useTranslation } from 'react-i18next';
import type { SisuActionKey } from '../SisuActionPopover/actionKey';
import { sisuActionPopoverBody, sisuActionPopoverTitle } from './sisuActionPopoverI18n';
import s from './TooltipSisuContent.scss';

interface Props {
  actionKey: SisuActionKey;
  onLoginClick: () => void;
  onJoinClick: () => void;
}

const TooltipSisuContent: React.FC<Props> = ({
  actionKey,
  onLoginClick,
  onJoinClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s['root']}>
      <div className={s['title']}>{sisuActionPopoverTitle(actionKey, t)}</div>
      <div className={s['body']}>{sisuActionPopoverBody(actionKey, t)}</div>
      <div className={s['actions']}>
        <GhostButton
          type="button"
          size="small"
          variant="main"
          fillContainerWidth
          onClick={onLoginClick}
        >
          {t('sisuFunnel.login')}
        </GhostButton>
        <BrandedButton
          type="button"
          size="small"
          variant="brand-green"
          fillContainerWidth
          onClick={onJoinClick}
        >
          {t('common.join')}
        </BrandedButton>
      </div>
    </div>
  );
};

TooltipSisuContent.displayName = 'TooltipSisuContent';

export default TooltipSisuContent;
